module.exports = __webpack_public_path__ + "img/avatar3.84756a9d.jpg";